module.exports = __webpack_public_path__ + "static/mongodb-replica-set-development-notes-01-291bea511dd03128b40ff94eed1cf463.png";